// Core
import { useState } from 'react';
import { NavLink, Link, useHistory, useLocation } from 'react-router-dom';

// Chakra 
import {
  Box,
  Button, Checkbox, Divider, Flex, FormControl, Input, Menu, MenuButton, MenuList, Select, 
  SimpleGrid, Text, InputGroup, InputLeftElement, RadioGroup, Stack, Radio, useDisclosure
} from '@chakra-ui/react';

// Components
import { SortIcon } from 'components/Icons/Icons';

const Sort = ({
	mapView,
	isPopular,
	setIsPopular,
	setIsLoadingPage
}) => {
	const history = useHistory();
	const handleSortChange = (value) => {
		const searchParams = new URLSearchParams(window.location.search);

		setIsLoadingPage(true);
		if(value === isPopular){
		  setIsPopular();
		  searchParams.delete('sort');
		} else {
		  setIsPopular(value);
		  searchParams.set('sort', value);
		}

		history.push({ search: searchParams.toString() }); 
	};

	const stateMapStyle = {
        opacity: '0.5',
        pointerEvents: 'none'
    };

	return (
		<Box style={ mapView ? stateMapStyle : {}}>
			<Menu variant="sort">
			    <MenuButton
					as={Button}
					leftIcon={<SortIcon color="#9FABCB" fontSize="24px" ml="0px" mr="0px" />}
					variant="secondary-md"
					color="white"
					p="0px 0px 0px 10px !important"
					w="44px" />

		        <MenuList
		            zIndex="999" 
		            borderRadius="20px">
					<Box mb="-8px">
		              <Text pb={4} variant="title-md" whiteSpace="nowrap">Sorting</Text>

		              <Stack>
		                {[
		                  { value: 'titleAsc', label: 'Title (A-Z)' },
		                  { value: 'titleDesc', label: 'Title (Z-A)' },
		                  { value: 'newest', label: 'Newest' },
		                  { value: 'oldest', label: 'Oldest' },
		                  { value: 'mostPop', label: 'Popular' },
		                  { value: 'saleDesc', label: 'Biggest Savings' },
		                ].map(({ value, label }) => (
		                  <Radio
		                    key={value}
		                    value={value}
		                    isChecked={isPopular === value}
		                    onClick={() => handleSortChange(value)}
		                  >
		                    <Text variant="text" onClick={() => handleSortChange(value)} ml="-15px" pl="12px">{label}</Text>
		                  </Radio>
		                ))}
		              </Stack>
		            </Box>
		        </MenuList>
		    </Menu>
	    </Box>
	);
};

export default Sort;